var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-card',[_c('v-card-title',{staticClass:"greyk lighten-4k"},[_c('h3',[_vm._v("Payroll")])]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}})],1)],1)],1)],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a44c4878","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/accountant/payroll/payroll.vue
// module id = QlVh
// module chunks = 0